import { notificationsRepository } from '@/services/repository-factory'

const actions = {
  setUnreadNotifications(unreadNotifications) {
    this.unreadNotifications = unreadNotifications
  },
  setNotifications(notifications) {
    this.notifications = notifications
  },
  async getNotifications(params) {
    this.isLoading = true
    const repository = await notificationsRepository.fetchNotifications(params)
    this.notifications = repository.data
    this.recordsFiltered = repository.recordsFiltered
    this.unreadNotifications = repository.unread_notifications
    this.isLoading = false
  },
  async read({ notificationId, params }) {
    const response = await notificationsRepository.readNotifications(notificationId)

    this.notifications = this.notifications.filter(
      (notification) => notification.id !== notificationId
    )
    this.unreadNotifications = response.unread_notifications

    if (this.notifications.length === 0 && this.unreadNotifications !== 0) {
      await this.getNotifications(params)
    }
  },
  async readAll(params) {
    await notificationsRepository.readAllNotifications()
    this.notifications = []
    await this.getNotifications(params)
  },
  async remove() {
    await notificationsRepository.removeNotifications()
    this.notifications = []
    this.unreadNotifications = 0
  }
}

export default actions
